import type {ReactElement} from 'react';
import {CustomItemControlsWrapper} from '@Components/poster-editor/components/custom-item-controls/components/custom-item-controls-wrapper/custom-item-controls-wrapper';
import {useAppSelector} from '@/hooks';

export function CustomItemControls(): ReactElement | null {
  const pageOrder = useAppSelector((state) => {
    return state.posterEditor?.posterObject?.pages.pageOrder;
  });

  if (window.posterEditor?.whiteboard?.mode.isWebpage() || window.posterEditor?.whiteboard?.mode.isGeneration()) {
    return null;
  }

  if (!pageOrder?.length) {
    return null;
  }

  return (
    <>
      {pageOrder.map((pageHashedId) => {
        return <CustomItemControlsWrapper key={pageHashedId} pageHashedId={pageHashedId} />;
      })}
    </>
  );
}
